import { render } from "./about.vue?vue&type=template&id=4d996902"
import script from "./about.js?vue&type=script&lang=js"
export * from "./about.js?vue&type=script&lang=js"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__